// extracted by mini-css-extract-plugin
export var allResults = "search-module--allResults--f6132";
export var searchBlock = "search-module--searchBlock--b82c4";
export var searchBlock__input = "search-module--searchBlock__input--ab5fe";
export var searchBlock__item = "search-module--searchBlock__item--ce848";
export var searchBlock__item__img = "search-module--searchBlock__item__img--16cca";
export var searchBlock__item__link = "search-module--searchBlock__item__link--94059";
export var searchBlock__results = "search-module--searchBlock__results--976ee";